<template>
  <div>
    <div v-if="role === 'ADMIN'">
      <VRow>
        <template v-if="getPermissionMixin('credits')">
          <VCol cols="6" md="4" lg="3">
            <CountItem
              color="green"
              icon="mdi-comment"
              title="تعداد پیامک های باقی مانده (آسانک)"
              :count="creaditsModel.asanak.credit"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              color="blue"
              icon="mdi-cash"
              title="     شارژ باقی مانده (کاوه نگار)"
              :count="`${Math.round(
                creaditsModel.kavenegar.credit
              ).toLocaleString()} ریال`"
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              color="blue"
              icon="mdi-calendar"
              title="تاریخ انقضای کاوه نگار"
              :count="
                creaditsModel.kavenegar.expire &&
                creaditsModel.kavenegar.expire == 0
                  ? '------'
                  : getPersianDate(creaditsModel.kavenegar.expire)
              "
            />
          </VCol>
          <VCol cols="6" md="4" lg="3">
            <CountItem
              color="blue"
              icon="mdi-calendar"
              title="شارژ پنل زیبال"
              :count="showZibal(creaditsModel.zibal.credit)"
            />
          </VCol>
        </template>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/drivers/turns"
            color="green"
            icon="mdi-book"
            title="رزرو های فعال"
            :count="reservationCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/remittance"
            color="blue"
            icon="mdi-book-arrow-down"
            title="حواله های جاری"
            :count="remittanceCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/orders"
            color="blue"
            icon="mdi-book-arrow-down"
            title="اعلام بار های فعال"
            :count="orderCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <div class="text-purple-500 bg-purple-100"></div>
          <div class="text-fuchsia-500 bg-fuchsia-100"></div>
          <div class="text-amber-500 bg-amber-100"></div>
          <div class="text-sky-500 bg-sky-100"></div>
          <CountItem
            route="/drivers"
            color="purple"
            icon="mdi-card-account-details"
            title="رانندگان"
            :count="driverCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/carslist"
            color="red"
            icon="mdi-truck"
            title="ناوگان"
            :count="carCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/companies"
            color="fuchsia"
            icon="mdi-office-building"
            title="شرکت ها"
            :count="companyCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/realPersonFactories"
            color="yellow"
            icon="mdi-account-group"
            title="کاربران"
            :count="factoryRealPersonCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/factories"
            color="amber"
            icon="mdi-office-building"
            title="واحد های صنفی"
            :count="factoryLegalPersonCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/access/admins"
            color="green"
            icon="mdi-account-circle"
            title="ادمین ها"
            :count="adminCount"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/receipts"
            color="sky"
            icon="mdi-comment-multiple"
            title="فیش های در انتظار"
            :count="pendingReceipt"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/support"
            color="yellow"
            icon="mdi-comment-eye"
            title="تیکت های باز"
            :count="openTicket"
          />
        </VCol>
        <VCol cols="6" md="4" lg="2">
          <CountItem
            route="/carbreakdown"
            color="stone"
            icon="mdi-car-cog"
            title="اعلام خرابی"
            :count="carBreakdownCount"
          />
        </VCol>
      </VRow>

      <VRow>
        <VCol cols="12" lg="6">
          <div class="bg-white rounded-lg shadow p-5">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span
                  class="w-8 h-8 rounded-lg text-blue-500 flex grow-0 items-center justify-center bg-blue-100"
                >
                  <v-icon style="color: inherit" size="19"
                    >mdi-account-circle-outline</v-icon
                  >
                </span>
                <h1 class="font-bold text-stone-600 mr-2">
                  ثبت نام های اخیر رانندگان
                </h1>
              </div>
              <!-- <router-link to="/turnOver">
                      <span class="text-[10px] text-blue-400">بیشتر</span>
                  </router-link> -->
            </div>
            <div class="mt-3">
              <span class="text-xs text-stone-400"
                >نمودار ثبت نامی رانندگان</span
              >
            </div>
            <div class="chartBox mt-5">
              <apexchart
                v-if="countDay"
                height="320"
                :options="chartOption"
                :series="seri"
              ></apexchart>
              <div
                v-else-if="loading"
                class="flex justify-center p-10 bg-slate-50 text-sm text-stone-400"
              >
                <v-progress-circular color="primary" indeterminate />
              </div>
              <div
                v-else
                class="text-center p-10 bg-slate-50 text-sm text-stone-400"
              >
                اطلاعاتی موجود نیست
              </div>
            </div>
          </div>
        </VCol>
        <VCol cols="12" lg="6">
          <div class="bg-white rounded-lg shadow p-5 h-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <span
                  class="w-8 h-8 rounded-lg text-fuchsia-500 flex grow-0 items-center justify-center bg-fuchsia-100"
                >
                  <v-icon style="color: inherit" size="19"
                    >mdi-message-bulleted</v-icon
                  >
                </span>
                <h1 class="font-bold text-stone-600 mr-2">
                  وضعیت ثبت نام های امروز
                </h1>
              </div>
              <!-- <router-link to="/turnOver">
                      <span class="text-[10px] text-blue-400">بیشتر</span>
                  </router-link> -->
            </div>
            <div class="mt-3">
              <span class="text-xs text-stone-400"
                >نمودار ثبت نام های امروز</span
              >
            </div>
            <div class="chartBox mt-5 h-full">
              <apexchart
                v-if="seriesDonut.length !== 0"
                height="320"
                :options="chartOptionsDonut"
                :series="seriesDonut"
              ></apexchart>
              <div
                v-else-if="loading"
                class="flex justify-center p-10 bg-slate-50 text-sm text-stone-400"
              >
                <v-progress-circular color="primary" indeterminate />
              </div>
              <div
                v-else
                class="text-center p-10 bg-slate-50 text-sm text-stone-400"
              >
                اطلاعاتی موجود نیست
              </div>
            </div>
          </div>
        </VCol>
      </VRow>
    </div>
    <Dashboard v-if="role !== 'ADMIN' && role" />
  </div>
</template>

<script>

import axiosApi from "@/plugins/axios";
import { convertDateOnly } from "@/plugins/getPersianDate";
import Dashboard from "@/components/Dashboard.vue";
import CountItem from "@/components/Dashboard/CountItem.vue";
export default {
  name: "index",
  components: { Dashboard, CountItem },
  watch: {
    dates() {
      this.translateDate();
    },
  },
  data() {
    return {
      creaditsModel: {
        zibal: {
          credit: 0,
        },
        kavenegar: {
          credit: 0,
          expire: 0,
        },
        asanak: {
          credit: 0,
        },
      },
      loading: false,
      seriesDonut: [],
      chartOptionsDonut: {
        chart: {
          type: "donut",
          background: "#f8fafc",
          fontFamily: "iranYekanBold, sans-serif",
        },
        colors: ["#66DA26", "#edba14", "#E91E63", "#2E93fA"],
        labels: ["واحد های صنفی", "کاربران", "شرکت ها", "رانندگان"],
        responsive: [
          {
            breakpoint: 1264,
            options: {
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      seri: [],
      chartOption: {},
      dateArray: [],
      remittanceCount: 0,
      driverCount: 0,
      reservationCount: 0,
      companyCount: 0,
      factoryRealPersonCount: 0,
      factoryLegalPersonCount: 0,
      adminCount: 0,
      pendingReceipt: 0,

      carCount: 0,
      openTicket: 0,
      carBreakdownCount: 0,
      orderCount: 0,
      role: "",
      dates: "",
      show: false,
      countDay: "",
    };
  },
  mounted() {
    if (
      this.getPermissionMixin("credits") &&
      localStorage.getItem("role") == "ADMIN"
    ) {
      this.getCreadits();
    }
    this.getRole();
    if (this.role === "ADMIN") {
      this.getCount();
    }
    if (localStorage.getItem("role") == null) {
      localStorage.clear();
      location.replace("/");
    }
  },
  methods: {
    showZibal(val) {
      if (typeof val == "string") {
        return val;
      } else {
        return Math.round(val).toLocaleString() +' '+' ریال';
      }
    },
    getRole() {
      this.role = localStorage.getItem("role");
    },
    getCreadits() {
      axiosApi()
        .get("v2/admin/credits")
        .then((result) => {
          // console.log(result);
          this.creaditsModel = result.data.data;
        })
        .finally(() => (this.loading = false));
    },
    getCount() {
      this.loading = true;
      axiosApi()
        .get("v2/admin/dashboard")
        .then((result) => {
          this.driverCount = result.data.data.driverCount;
          this.reservationCount = result.data.data.reservationCount;
          this.remittanceCount = result.data.data.RemittanceCount;
          this.carCount = result.data.data.carCount;
          this.factoryRealPersonCount = result.data.data.factoryRealPersonCount;
          this.factoryLegalPersonCount =
            result.data.data.factoryLegalPersonCount;
          this.companyCount = result.data.data.company;
          this.openTicket = result.data.data.openTicket;
          this.carBreakdownCount = result.data.data.carBreakdownCount;
          this.orderCount = result.data.data.orderCount;
          this.adminCount = result.data.data.adminCount;

          this.orderCount = result.data.data.orderCount;

          this.dates = result.data.data.dates.reverse();
          this.countDay = result.data.data.date_count.reverse();

          this.seriesDonut = [
            result.data.data.factoryLegalRegisterToday,
            result.data.data.factoryRealRegisterToday,
            result.data.data.companyRegisterToday,
            result.data.data.driverRegisterToday,
          ];

          this.seri = [
            {
              name: "تعداد ثبت نام",
              data: this.countDay,
            },
          ];
          this.chartOption = {
            // colors: ['#9155fd'],
            chart: {
              type: "area",
              background: "#f8fafc",
              fontFamily: "iranYekanBold, sans-serif",
              foreColor: "#a8a29e",
              zoom: {
                autoScaleYaxis: true,
                enabled: true,
                type: "x",
              },
              toolbar: {
                autoSelected: "pan",
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: false,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset:
                    true | '<img src="/static/icons/reset.png" width="20">',
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            fill: {
              gradient: {
                enabled: true,
                opacityFrom: 0.55,
                opacityTo: 0,
              },
            },
            xaxis: {
              type: "text",
              categories: this.dates,
              labels: {
                rotate: -0,
              },
              tickAmount: 4,
              max: this.dates.length,
              min: this.dates.length - 5,
              floating: true,
            },
            yaxis: {
              floating: true,
              min: 0,
              tickAmount: 5,
            },
            stroke: {
              width: "3",
              curve: "smooth",
            },
            markers: {
              size: 5,
              colors: ["#fff"],
              strokeColor: "#00BAEC",
              strokeWidth: 3,
            },
            grid: {
              yaxis: {
                lines: {
                  show: false,
                },
              },
              padding: {
                left: 30,
                bottom: 30,
              },
              borderColor: "#ececec",
            },
          };
        })
        .finally(() => (this.loading = false));
    },
    translateDate() {
      this.show = true;
      for (let i = 0; i < 7; i++) {
        this.dates[i] = this.getPersian(this.dates[i]);
      }
    },
    getPersian(date) {
      return convertDateOnly(date);
    },
  },
};
</script>

<style scoped>
.blue {
  margin-top: 7px;
  margin-left: 7px;
  width: 12px;
  height: 12px;
  left: 290px;
  border-radius: 128px;
}

.reportLine {
  margin: 10px;
}

.flex {
  display: flex;
}
.trend {
  height: 100%;
}
@media screen and (max-width: 600px) {
  .flex {
    display: unset;
  }

  .trend {
    padding-top: 40px;
  }
}
</style>
